export function canViewEmployeeIdeas(auth) {
    const user = auth?.user
    if (!user) {
        return false
    }
    if (user.is_ideas_viewer === true || user.is_ideas_viewer === 'true') {
        return true
    }
    return !!user.role?.abilities?.employee_ideas
}
